import React, { useEffect, useRef } from 'react'
import { useCountUp } from 'react-countup'
import { Text } from '@macist-m/robinia-uikit'

interface CardValueProps {
  value: number
  decimals?: number
  fontSize?: string
  prefix?: string
  color?:string
}

const CardValue: React.FC<CardValueProps> = ({ value, decimals, fontSize = '40px', prefix ,color}) => {
  const { countUp, update } = useCountUp({
    start: 0,
    end: value,
    duration: 1,
    separator: ',',
    decimals:
      // eslint-disable-next-line no-nested-ternary
      decimals !== undefined ? decimals : value < 0 ? 4 : value > 1e5 ? 0 : 3,
  })

  const updateValue = useRef(update)

  useEffect(() => {
    updateValue.current(value)
  }, [value, updateValue])
  console.log(color)
  return (
    <Text color={color !== undefined ? color : "card"}  bold fontSize={fontSize} >
      {prefix}
      {countUp}
    </Text>
  )
}

export default CardValue
